import React from 'react';
import styles from '../../index.module.scss';
import Button from 'components/Button';
import Icon from 'components/Icon';
import toolsEventMap from 'components/ReaderTools/toolsEventMap';
import { useGAEvent } from 'components/AppService/GAService';
import { withTranslation } from 'react-i18next';

const BasicReaderToolComponent = ({ t, type, clickHandlerParameters = [] }) => {
    const { gaEvent } = useGAEvent();
    const tool = toolsEventMap[type];
    return (
        <Button
            key={type}
            onClick={() => {
                if (tool.ga) gaEvent(tool.ga);
                tool.clickHandler(...clickHandlerParameters);
            }}
            title={t(tool.title)}
        >
            <Icon name={tool.icon} />
            <div className={styles.text}>{t(tool.title)}</div>
        </Button>
    );
};

export default withTranslation()(BasicReaderToolComponent);
